package dev.bitspittle.droidconSf24.pages.sections.kobweb.basics

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import dev.bitspittle.droidconSf24.components.widgets.*
import dev.bitspittle.droidconSf24.components.examples.*
import dev.bitspittle.droidconSf24.utilities.dataId
import dev.bitspittle.droidconSf24.utilities.attr
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.icons.fa.IconStyle as FaIconStyle
import com.varabyte.kobweb.silk.components.icons.mdi.*
import com.varabyte.kobweb.silk.components.icons.mdi.IconStyle as MdiIconStyle
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.fr

@Page
@Composable
fun ArchitecturePage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("sections/kobweb/basics/Architecture.md", mapOf("follows" to listOf("WhyKobweb")))) {
        dev.bitspittle.droidconSf24.components.layouts.SectionLayout {
            org.jetbrains.compose.web.dom.H2(attrs = { id("architecture") }) {
                Kobweb()
                org.jetbrains.compose.web.dom.Text(" Architecture")
            }
            Grid(2) {
                Captioned("CLI") {
                    org.jetbrains.compose.web.dom.P {
                        FaTerminal()
                    }
                }
                Captioned("Gradle plugins") {
                    org.jetbrains.compose.web.dom.P {
                        FaScrewdriverWrench()
                    }
                }
                Captioned("Server") {
                    org.jetbrains.compose.web.dom.P {
                        FaServer()
                    }
                }
                Captioned("Library") {
                    org.jetbrains.compose.web.dom.P {
                        FaCode()
                    }
                }
            }
            SpeakerNotes {
                org.jetbrains.compose.web.dom.Ul {
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("CLI version and library version are not the same!")
                    }
                }
            }
        }
    }
}
